import template from './creditors.html';
import controller from './creditors.controller';

let creditorsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default creditorsComponent;
